/**
 * Color constants for the application FROM ortus-light/_colors
 * These colors are extracted from the design system
 */

// COLORS USED IN CHARTS TS/JSON Config
export const PRIMARY_BLACK = '#141414';
export const SECONDARY_BLACK = '#505050';
export const FOCUSED_OUTLINE = '#000F41';
export const PURE_BLACK = '#000000';
export const PURE_WHITE = '#ffffff';
export const ACTIVE_BLUE = '#1F9DFF';
export const VIBRANT_BLUE_CODE = '#0303B8';
export const VIBRANT_BLUE_80 = '#CDCDF1';
export const VIBRANT_PURPLE = '#BB23E0';
export const ACTIVE_BLUE_50 = '#D5EDFF';
export const ACTIVE_GREEN = '#1AFF80';
export const ACTIVE_GREEN_60 = '#DEFFEC';
export const TERTIARY_GREEN_60 = '#15bd5e';
export const TERTIARY_GREEN_80 = '#107C3C';
export const TERTIARY_GREEN_110 = '#0B5E2E';
export const TERTIARY_YELLOW_60 = '#FFDD2D';
export const TERTIARY_YELLOW_110 = '#393204';
export const ACTIVE_BLUE_60 = '#bfe3ff';
export const TERTIARY_YELLOW_30 = '#FFF2B2';
export const RADIANT_ORANGE_50 = '#FBA05E';
export const RADIANT_ORANGE_70 = '#FF740F';
export const RADIANT_ORANGE_110 = '#AF7927';
export const TERTIARY_RED_30 = '#FFC8CB';
export const TERTIARY_RED_60 = '#FC4B53';
export const TERTIARY_RED_80 = '#A61920';
export const DARK_ORANGE = '#692C01';
export const GREY_01 = '#8C8C8C';
export const GREY_03 = '#DCDCDC';
export const GREY_04 = '#e6e6e6';
export const GREY_05 = '#F0F0F0';
export const GREY_06 = '#F5F5F5';
export const TOOLTIP_BORDER_COLOR = '#2b3242';

// UTILIZATION CATEGORY COLORS
export const UTILIZATION_CATEGORY_COLORS = {
  production: TERTIARY_GREEN_60,
  cip: ACTIVE_BLUE,
  slowing_down: TERTIARY_YELLOW_60,
  standstill: RADIANT_ORANGE_50,
  startup: ACTIVE_GREEN,
  standby: GREY_04,
};

// DATA QUALITY THRESHOLD VALUES
export const THRESHOLD_POOR_MAX = 49;
export const THRESHOLD_OKAY_MAX = 69;
export const THRESHOLD_GOOD_MAX = 70;

// GLOBAL CONSTANTS
export const NUMBER_OF_DIGITS = 1;
export const FILTER_DATE_FORMAT = 'yyyy-MM-dd';
export const PICTOGRAM_WIDTH = 400;
export const PICTOGRAM_HEIGHT = 400;
